import React from 'react';
import {connect} from "react-redux";
import Select from "react-select";
import * as utils from "../../../utils/clientRate";
import l10n from "../../../l10n/localization";
import {Button} from "react-materialize";
import ClientRateForm from "../ClientRateForm";
import * as clientRateActions from "../../../actions/clientRate";
import * as utilsCommon from "../../../utils/utils";
import * as creationActions from "../../../actions/creation";

class SelectClientRates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {...props.formData};
    }

    componentDidMount() {
        utilsCommon.notNullNorUndefined(this.props.schema.fog.client) &&
            this.props.dispatch(clientRateActions.fetchRates(this.props.schema.fog.client.id, true));
    }

    onChange(value) {
        this.props.onChange(value);
    }

    render() {
        return (
            <div className="form-group field">
                <Button type="button" floating onClick={() => this.props.schema.openDrawer(ClientRateForm, {item: null, fog: this.props.schema.fog}, creationActions.destroyingnewlyCreatedClientRate())} icon="add" className="add-button btn-md ml5"/>

                <label className="control-label" htmlFor="root_clientrates">
                    {l10n.cargo.clientRate}
                </label>

                <Select
                    backspaceRemoves={false}
                    className="form-control"
                    name="root_clientrates"
                    value={this.props.formData}
                    options={utils.clientRatesToSelect(this.props.clientRates)}
                    isLoading={this.props.loading}
                    clearable={false}
                    onChange={this.onChange.bind(this)}
                    simpleValue
                    valueComponent={(props) => {
                        return (
                            <div className="Select-value" title={props.value.title}>
                                <span className="Select-value-label">
                                    {props.children}
                                    <div className="pull-right mr25 input-button-wrapper">
                                        <i>
                                            <Button type="button" floating onClick={() => this.props.schema.openDrawer(ClientRateForm, {item: props.value.item, fog: this.props.schema.fog}, creationActions.destroyingnewlyCreatedClientRate())} icon="edit" className="edit-button small"/>
                                        </i>
                                    </div>
                                </span>
                            </div>
                        )
                    }}
                />
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        clientRates: state.clientRate.clientRates,
        loading: state.clientRate.loading
    });
})(SelectClientRates);


// WEBPACK FOOTER //
// ./src/components/forms/fields/SelectClientRates.js